import type { ReadonlyDeep } from 'type-fest';

import { CostTypeEnum, FixedCostInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';

import type { FixedCostInput as IFixedCostInput } from '../hooks/useCreateFixedCostMutation.hook';
import type { CostForm_FixedCost } from '../fragments/fixed-cost.fragment';

import { amountForm2ApiMapper } from './amount.form2api.mapper';

export function fixedCostForm2ApiMapper(
  fixedCost: ReadonlyDeep<CostForm_FixedCost>,
): ReadonlyDeep<IFixedCostInput> {
  const fixedCostInput = pruneInput(fixedCost, FixedCostInput);

  return {
    ...fixedCostInput,
    amount: amountForm2ApiMapper(fixedCost.amount),
    kind: CostTypeEnum.FixedCost,
    codingConfig: codingConfigForm2ApiMapper(fixedCost.codingConfig),
  };
}
